import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const GridContainerTitle = styled("span")(() => ({
  color: "#475467",
  fontSize: "16px",
  fontFamily: "Manrope",
  fontWeight: 700,
  lineHeight: "24px",
}));

export const MapGeneratedWrapper = styled(Grid)(() => ({
  alignSelf: "stretch",
}));

export const MapGeneratedContainer = styled("div")(() => ({
  borderRadius: "12px",
  background: "#FCFCFD",
  display: "flex",
  flexDirection: "column",
  padding: "16px 24px",
  gap: "24px",
  height: "100%",
  width: "100%",
}));

const styles = makeStyles(() => ({
  warehouseMapModal: {
    width: "80vw !important",
  },

  resetButton: {
    marginRight: "16px",
  },
}));

export default styles;
